import { UseQueryResult, skipToken, useQuery } from "@tanstack/react-query";
import hashStringFunction from "utils/hashString";

export const linkURLKeys = {
  any: ["getLinkURL"],
  one: ({
    redirect,
    userId,
    clientId,
  }: {
    redirect: string | undefined;
    userId: string | undefined;
    clientId: string | undefined;
  }) => [...linkURLKeys.any, { redirect, userId, clientId }],
};

const customUrlUserIds: Record<string, string> = {
  "6bd3cd265f8f8b43cb2dcbd6cba9481b38cdc3d799ade230d2b19d5e35fb753b":
    "american-express.codat.io",
  dc885ee69ca5ea58607b51232cf0463238816a7279c4769398d6ca6347aed3b4:
    "american-express.codat.io",
  // mocks
  b50b9edfad1f0c6400c3adebb979fd512a7580010f74d77c0b27fa6039f5b1ba:
    "mock-user-id.codat.io",
  "mock-user-id": "mock-user-id.codat.io",
};

const customUrlClientIds: Record<string, string> = {
  "86e162bde1b9b3897d1960f274140eebc18fe1be397aa9710d425df3f2c66c9c":
    "bmo.codat.io",
  // mocks
  ddc20dfb29db39e18ff5bfaa9cf4314f8938dabb11afc4442e63adcfb0383d3f:
    "mock-client-id.codat.io",
  "mock-client-id": "mock-client-id.codat.io",
};

export const useGetLinkURL = ({
  redirect,
  userId,
  clientId,
}: {
  redirect: string | undefined;
  userId: string | undefined;
  clientId: string | undefined;
}): UseQueryResult<string | undefined> => {
  return useQuery<string | undefined>({
    staleTime: 60 * 60_000,
    queryKey: linkURLKeys.one({ redirect, userId, clientId }),
    queryFn: redirect
      ? async () => {
          const redirectUri = new URL(redirect);
          const hashedUserId = await hashStringFunction(userId);
          const hashedClientId = await hashStringFunction(clientId);

          const customClientUrl = hashedClientId
            ? customUrlClientIds[hashedClientId]
            : undefined;
          const customUserUrl = hashedUserId
            ? customUrlUserIds[hashedUserId]
            : undefined;
          const customUrl = customClientUrl ?? customUserUrl;

          if (customUrl) {
            redirectUri.hostname = customUrl;
            return redirectUri.toString();
          }

          return redirect;
        }
      : skipToken,
  });
};
